import * as React from 'react'
import { Row, Col, Card, CardBody, CardTitle } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Timeline extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props.information ? this.props.information.sort((a,b) => a.order - b.order) : null,
            bottomTitle: null,
            bottomIcon: null
        }
    }


    componentDidUpdate(prevProps){
        if(prevProps.name !== this.props.name){
            this.setState({
                data: this.props.information ? this.props.information.sort((a,b) => a.order - b.order) : null
            },() => {
                this.props.information.map(elem => {
                    if(elem.extra && elem.status === 'selected'){
                        console.log(elem.status_name)
                        this.setState({
                            bottomTitle: elem.extra.extra_info,
                            bottomIcon: elem.extra.icon
                        })
                    }else{
                        this.setState({
                            bottomTitle: null,
                            bottomIcon: null
                        })
                    }
                })
            })
        }

    }

    componentDidMount(){
        this.state.data.map(elem => {
            if(elem.extra && elem.status === 'selected'){
                this.setState({
                    bottomTitle: elem.extra.extra_info,
                    bottomIcon: elem.extra.icon
                })
            }else{
                this.setState({
                    bottomTitle: null,
                    bottomIcon: null
                })
            }
        })
    }

    renderLine(value,status,length){
        if(value === 1){
            // primeiro elemento da timeline
            return (
                <React.Fragment>
                    <div className={`timeline--element-line__top timeline--element-line__null`} />
                    <div className={`
                            timeline--element-line__middle
                            timeline--element-line__middle-${status}
                        `}
                    >
                        <div  
                            className={`
                                timeline--element-line__square
                                timeline--element-line__${status === "selected" && "selected"}
                            `}
                        />
                    </div>
                    <div className={`timeline--element-line__bottom timeline--element-line__${status === "selected" || status === "inactive" ? "inactive" : "active"}`} />
                </React.Fragment>
            )
        }else if(value === length){
            // ultimo elemento da timeline
            return (
                <React.Fragment>
                    <div className={`timeline--element-line__top timeline--element-line__${(status === "selected" || status === "active") ? "active" : "inactive"}`} /> {/* "active" : "inactive"*/}
                    <div className={`
                            timeline--element-line__middle
                            timeline--element-line__middle-${status}
                        `}
                    >
                        <div className={`timeline--element-line__square timeline--element-line__${status === "selected" && "selected"}`} />
                    </div>
                    <div className={`timeline--element-line__bottom timeline--element-line__null`} />
                </React.Fragment>
            )
        }else{
            //demais elementos
            //Funciona, mas gostaria de tornar mais eficiente
            if(status === "selected"){
                return (
                    <React.Fragment>
                        <div className={`timeline--element-line__top timeline--element-line__active`} />
                        <div className={`
                            timeline--element-line__middle
                            timeline--element-line__middle-${status}
                        `}
                    >
                            <div className="timeline--element-line__square timeline--element-line__selected" />
                        </div>
                        <div className={`timeline--element-line__bottom timeline--element-line__inactive`} />
                    </React.Fragment>
                )
            }else{
                return (
                    <React.Fragment>
                        <div className={`timeline--element-line__top timeline--element-line__${status}`} />
                        <div className={`
                            timeline--element-line__middle
                            timeline--element-line__middle-${status}
                        `}
                    >
                            <div className="timeline--element-line__square" />
                        </div>
                        <div className={`timeline--element-line__bottom timeline--element-line__${status}`} />
                    </React.Fragment>
                )
            }
            
        }
    }

    render() {
        const { data } = this.state
        return (
            <React.Fragment>
                <div className="timeline text-center">
                    <div>
                        <CardTitle className="timeline--name">
                            <div className="timeline--img">
                                {this.props.image && this.props.image}
                            </div>
                            {this.props.name && this.props.name}
                        </CardTitle>
                        {
                        data &&
                            <div className="timeline--information">
                                {data.map((elem, index) => {
                                    return <Row key={index} className="timeline--element">
                                        {elem.status !== "inactive"
                                            ? <Col xs={4} className={`px-1 align-self-center timeline--element-information ${elem.status === "active" && "timeline--element-information__active"} `}
                                               >
                                                <div className="timeline--element-information__main">
                                                    {elem.information}
                                                </div>
                                                <div className="timeline--element-information__sub-info">
                                                {   elem.sub_information && elem.sub_information}
                                                </div>
                                            </Col>
                                            : <Col xs={4} className="px-1 align-self-center timeline--element-information" />
                                        }
                                        <Col xs={1} className="px-0 timeline--element-line align-self-center">
                                            {this.renderLine(elem.order, elem.status, data.length)}
                                        </Col>
                                        <Col xs={7} className="pl-1 align-self-center">
                                            <div className={`timeline--element-status timeline--element-status__${elem.status}`}>
                                                <span>
                                                    {elem.status_name}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                })}
                            </div>
                        }
                        
                    </div>
                        <div className="timeline--name">
                            <div className="timeline--img">
                                {this.state.bottomIcon && this.state.bottomIcon}
                            </div>
                            {this.state.bottomTitle && this.state.bottomTitle}
                        </div>
                </div>
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/Timeline.js